module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/20-57522efcfd1212716b60835dd13bd2db.svg";